module.exports = __webpack_public_path__ + "static/media/test20_3.af6e1f04.png";